var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 153 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 157,
    rx: 76.5,
    fill: "#5B5B5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.768 80.7678C105.744 79.7915 105.744 78.2085 104.768 77.2322L88.8579 61.3223C87.8816 60.346 86.2986 60.346 85.3223 61.3223C84.346 62.2986 84.346 63.8816 85.3223 64.8579L99.4645 79L85.3223 93.1421C84.346 94.1184 84.346 95.7014 85.3223 96.6777C86.2986 97.654 87.8816 97.654 88.8579 96.6777L104.768 80.7678ZM42 81.5H103V76.5H42V81.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavarrow);
export default __webpack_public_path__ + "static/media/navarrow.3381b6c97daf7340f0c20a592188f466.svg";
export { ForwardRef as ReactComponent };